import { render } from "./SidebarHeader.vue?vue&type=template&id=69cf7db0&scoped=true"
import script from "./SidebarHeader.vue?vue&type=script&lang=js"
export * from "./SidebarHeader.vue?vue&type=script&lang=js"

import "./SidebarHeader.vue?vue&type=style&index=0&id=69cf7db0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cf7db0"]])

export default __exports__